


export const normalizeString = (value: string) => {
    return value.normalize('NFD').replace(/\p{Diacritic}/gu, '').replaceAll(' ','').trim().toLowerCase()
}